export const state = () => ({
    loginCallBack: null,
});
export const mutations = {
    SET_LOGIN_CALLBACK(state, loginCallBack) {
        state.loginCallBack = loginCallBack;
    },
};
